import script from "./GameDetailPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./GameDetailPopup.vue?vue&type=script&setup=true&lang=js"

import "./GameDetailPopup.vue?vue&type=style&index=0&id=c4784ca6&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4784ca6"]])

export default __exports__